module.exports = __webpack_public_path__ + "img/Mask Group.cec06457.png";